<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header p-2" style="height:64px">
                <h5 class="modal-title">Share with</h5>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
                    <span aria-hidden="true">
                        <cancel-icon class="close-icon" style="height: 40px !important;
                            width: 40px !important;
                            color: #fff;">
                        </cancel-icon>
                        </span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                      <div class="d-inline-flex" style="margin-inline-end:25px;">
                        <input type="radio" id="DAM-shareInChat_users_filter" value="users" v-model='enabledFilter'  @change='enableUsersFilter()' class="bg-transparent border rounded text-light bigger-checkboxes" name="userOrchannel"/>
                        <label for="DAM-shareInChat_users_filter" style="position: relative;bottom: 1px;inset-inline-start:5px">Users</label>
                      </div>
                      <div v-if="checkIfChatPro" class="d-inline-flex w-25">
                        <input type="radio" value="channels" id="DAM-shareInChat_channels_filter" v-model='enabledFilter' @change='enableChannelsFilter()' class="bg-transparent border rounded text-light bigger-checkboxes" name="userOrchannel"/>
                        <label for="DAM-shareInChat_channels_filter" style="position: relative;bottom: 1px;inset-inline-start:5px">Channels</label>
                      </div>
                    </div>
                    <div>
                        <Multiselect
                            v-if='enabledFilter == "channels" && checkIfChatPro'
                            v-model="selectedChannels" 
                            :options="allChannelsList"
                            :multiple="true"
                            track-by="_id"
                            :custom-label="channelLabelCallback"
                            :close-on-select="false"
                            deselectLabel =""
                            selectLabel=""
                            selectedLabel=""
                            placeholder="Select channel" 
                            ref="messageChannels"
                            :hideSelected="false"
                            @remove="removeSelectedChannel($event)"
                            @select="selectedOptions($event)"
                            :searchable="true"
                            >
                            <div slot="tag" :title="option.option.channel_name"  slot-scope="option" class="tags-style">
                                <div class="user-name-display user-name-display-as-tags ellipsis-to-entry">#{{option.option.channel_name}}</div>
                                <div class="remove-tag" v-on:click.stop.prevent="removeSelectedChannel(option.option)">
                                  <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </div>
                            </div>
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.channel_name"/>
                            <span style="margin-inline-start:12px;">#{{ scope.option.channel_name }}</span>
                            </div>
                            <span slot="noResult">No results</span>
                            <span slot="noOptions" style="display:none"></span>
                        </Multiselect>
                        <Multiselect
                            v-if='enabledFilter == "users"'
                            v-model="selectedUsers" 
                            :options="allUsersList"
                            :multiple="true"
                            track-by="_id"
                            :custom-label="userLabelCallback"
                            :close-on-select="true"
                            deselectLabel =""
                            selectLabel=""
                            selectedLabel=""
                            ref="messageUsers"
                            placeholder="Select user" 
                            :hideSelected="false"
                            @remove="removeSelectedUser($event)"
                            @select="selectedUserOptions($event)"
                            :searchable="true"
                            >
                            <div slot="tag" :title="option.option.username"  slot-scope="option" class="tags-style">
                                <div :title="option.option.username" v-if="Object.keys(option.option).includes('profile_image') && !['undefined',null].includes(option.option.profile_image) && option.option.profile_image" class='user-name-or-image-in-selected-option'>
                                  <img :src="getProxyConvertedImage(option.option.profile_image)" @error="replaceWithUserIcon($event)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;">
                            </div>
                            <div v-else class="user-name-or-image-in-selected-option" :style="style(option.option.username)">{{ option.option.username.split("")[0] }}</div>
                            <div class="user-name-display user-name-display-as-tags ellipsis-to-entry">{{option.option.username}}</div>
                                <div class="remove-tag" v-on:click.stop.prevent="removeSelectedUser(option.option)">
                                  <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </div>
                            </div>
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeUsersCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.username"/>
                            <div :title="scope.option.username" v-if="Object.keys(scope.option).includes('profile_image') && !['undefined',null].includes(scope.option.profile_image) && scope.option.profile_image" class='user-name-or-image-in-selected-option'>
                              <img :src="getProxyConvertedImage(scope.option.profile_image)" @error="replaceWithUserIcon($event)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;">
                            </div>
                            <div v-else class="user-name-or-image-in-selected-option" :style="style(scope.option.username)">{{ scope.option.username.split("")[0] }}</div>
                              <span style="margin-inline-start:12px;">{{ scope.option.username }}</span>
                            </div>
                            <span slot="noResult">No results</span>
                            <span slot="noOptions" style="display:none"></span>
                        </Multiselect>
                    </div>
                    <div>
                        <textarea type="text"
                            class="bg-transparent border rounded text-light form-control input-fields"
                            style="padding: 8px;margin-top: 10px;height: 181px;resize:none" placeholder="Add a message" v-model="description">
                        </textarea>
                    </div>
                </div>
                <div class="modal-footer p-0">
                <div class="primary-btn-style">
                    <button
                    @click="sendMessageToSelectedUserOrChannel()"
                    class="btn btn-outline-primary"
                    data-v-198e7d7f=""
                    style="position: relative; float: inline-end; inset-inline-end :0"
                    >
                    Send
                    </button>
                    <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"  v-on:click="close()">Cancel</button>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapActions,mapGetters} from "vuex";
import CancelIcon from "../core/InlineCancelField.vue";
import Utils from "../../components.utils.js";

export default {
    props:['fileInfo','url', 'message'],
    components:{
        "Multiselect":Multiselect,
        "cancel-icon":CancelIcon
    },
    data(){
        return {
            selectedUsers: [],
            allChannelsList:[],
            allUsersList:[],
            selectedChannels:[],
            enableUsers:true,
            enabledFilter:'users',
            description:'',
            show:false,
        }
    },
    computed:{
      checkIfChatPro(){
          if(this.getInstalledPluginsData){
              let chatIndex = this.getInstalledPluginsData.findIndex(e => e.plugin_name == "Chat")
              if(chatIndex > -1){
                  return false;
              }else{
                  return true;
              }
          }
          return true;
      },
    ...mapGetters('pluginRepo',["getInstalledPluginsData"])
    },
    methods:{
        getProxyConvertedImage(image_url){
            return Utils.convertToLoginIPDomainName(image_url);
        },
        style(name){
            let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
            }
            return style
        },
        getProfileImageOfUser(image){
            let defaultImage = Utils.getNoThumbnailImg()
            let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
            return profileImageTag;
        },
        replaceWithUserIcon(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        channelLabelCallback(option){
            return '#' + option.channel_name;
        },
        userLabelCallback(option){
            return '#' + option.username;
        },
        enableUsersFilter(){
          this.enabledFilter = 'users';
          localStorage.setItem("shareWithFilterType",'users');
          if(this.allUsersList.length == 0){
            this.usersList();
          }
          this.$nextTick(() => {
            this.$refs['messageUsers'].$el.focus();
          })
        },
        enableChannelsFilter(){
          this.enabledFilter = 'channels';
          localStorage.setItem("shareWithFilterType",'channels');
          if(this.allChannelsList.length == 0){
            this.channelsList();
          }
          this.$nextTick(() => {
            this.$refs['messageChannels'].$el.focus();
          })
        },
        usersList() {
            this.getChatUsersFromServer().then((data) => {
                this.allUsersList = data['users'];
            })                  
        },
        channelsList(){
            this.getChannelsFromServer().then((data) => {
                this.allChannelsList = data['message_channels'];
            })
        },
        makeCheckBoxSelection(option){
                return this.selectedChannels.some((op) => op._id === option._id);
        },
        makeUsersCheckBoxSelection(option){
                return this.selectedUsers.some((op) => op._id === option._id);
        },
        selectedOptions(option){
            let index = this.allChannelsList.findIndex(item => item._id == option._id);
            if(index > -1){
                this.allChannelsList[index].checked = true;
            }
        },
        selectedUserOptions(option){
            let index = this.allUsersList.findIndex(item => item._id == option._id);
            if(index > -1){
                this.allUsersList[index].checked = true;
            }
        },
        removeSelectedChannel(option){
            let index = this.allChannelsList.findIndex(item => item._id == option._id);
            if(index > -1){
                this.allChannelsList[index].checked = false;
                this.selectedChannels = this.selectedChannels.filter(e => e._id != option._id)
            }
        },
        removeSelectedUser(option){
          let index = this.allUsersList.findIndex(item => item._id == option._id);
            if(index > -1){
                this.allUsersList[index].checked = false;
                this.selectedUsers = this.selectedUsers.filter(e => e._id != option._id)
            }
        },
        close(){
            this.$emit("close")
        },
        sendMessageToSelectedUserOrChannel(){
          let attachments = [], urlInToDescription = this.description;
          if(this.fileInfo){
            if(this.fileInfo.file_uid){
              attachments = [this.fileInfo.file_uid];
            }else if(this.fileInfo.asset_type == 'subclip'){
              attachments = [this.fileInfo.asset_id];
            }
          }
          if(this.url){
            urlInToDescription = this.url + ' ' + this.description;
          }
          if(this.selectedUsers.length == 0 && this.selectedChannels.length == 0){
            alert("Please select user or channel");
            return false;
          }
          if(this.enabledFilter == 'users'){
              for(let u = 0; u < this.selectedUsers.length; u++){
                 let payload = {};
                  payload= {"chat_unique_id":this.getLoggedInUserId()+'_'+this.selectedUsers[u]._id,"sender_id": this.getLoggedInUserId(),"receiver_id":this.selectedUsers[u]._id,
                  "receiver_type":"user","status":"new","message":urlInToDescription,"pid":"0"}
                  if(attachments.length){
                    payload['attachments'] = attachments;
                  }
                  if(this.fileInfo && this.fileInfo.asset_type == 'subclip'){
                    payload['attachment_type'] = 'subclip';
                  }else{
                    payload['attachment_type'] = 'file';
                  }
                  if(this.message){
                    payload['shared_msg_id'] = this.message._id;
                  }
                  this.sendMessageThroughChat(payload).then((data) => {
                      if (Utils.isAcceptedStatusCode(data.statusCode)) {
                          this.$toast.success("Shared in chat");
                          this.close();
                      }else{
                          this.$toast.success("Faild to share in chat");
                      }

                  })
              }
          }else{
            for(let u = 0; u < this.selectedChannels.length; u++){
                 let payload = {};
                  payload= {"sender_id": this.getLoggedInUserId(),"receiver_id":this.selectedChannels[u]._id,
                  "receiver_type":"group","status":"new","message":urlInToDescription,'attachments':attachments,"pid":"0"}
                  if(attachments.length){
                    payload['attachments'] = attachments;
                  }
                  if(this.message){
                    payload['shared_msg_id'] = this.message._id;
                  }
                  this.sendMessageThroughChat(payload).then((data) => {
                      if (Utils.isAcceptedStatusCode(data.statusCode)) {
                          this.$toast.success("Shared in chat");
                          this.close();
                      }else{
                          this.$toast.success("Faild to share in chat");
                      }

                  })
              }
          }
        },
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserInfo"]),
        ...mapActions('miscellaneous',['getChannelsFromServer','getChatUsersFromServer','sendMessageThroughChat'])
    },
    created(){
        this.enabledFilter = localStorage.getItem("shareWithFilterType");
        if(this.enabledFilter == 'users'){
          this.usersList();
        }else if(this.enabledFilter == 'channels'){
          this.channelsList();
        }
    },
    watch: {
      'show': function (val) {
        if (val) {
            this.$nextTick(() => {
            if(this.enabledFilter == 'users'){
              this.$refs['messageUsers'].$el.focus()
            }else{
              this.$refs['messageChannels'].$el.focus()
            }
          })
        }
      }
    },
    mounted(){
      setTimeout(() => {
        this.show = true;
        if(!this.checkIfChatPro){
          document.getElementById("DAM-shareInChat_users_filter").click();
        }
      }, 200)
    },
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;

.form-control{
  border: $border-color !important;
}

textarea:focus{
    outline: none;
    bottom: 0px;
    inset-inline-start: 0px;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}

.modal-dialog {
    max-width: 700px;
    width: 800px;
    height: 450px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
     background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 300px;
      user-select: text !important; 
      cursor:text;
      overflow:auto;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 15%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
      padding: 1%;
    }
}

.modal-header .close {
    margin: -1rem -13px -1rem auto !important;
}

.tags-style{
    display: inline-flex;
    margin-inline-end: 5px;
    margin-bottom: 2px !important;
    height: 27px;
    margin-inline-start: 3px;
  .user-name-display-as-tags{
      line-height: 27px;
      margin-inline-start: 6px;
  }
}

.search-bar{
  background: $primary-background!important;
  height:40px;
  width: 250px !important;
  float: inline-start;
  padding-inline-start: 12px;
  padding-bottom: 2px;
  border:$border-color !important;
}

.height-set{
  height: calc(100vh - 170px);
  background: $primary-background;
  .group-name{
    text-align: start;
    padding:16px 3%;
    font-size:27px;
    display:flex;
  }
  .group-members{
    height: calc(100% - 90px);
    cursor: pointer;
  }
}

.add-user-icon-wrapper{
    height: 59px;
    width: 60px;
    line-height: 54px;
    border-radius: 6px;
    background: $primary-background;
    color: $add-button-text-color;
    border: 1px solid $add-button-border-color; 
    display:flex;
    svg{
      margin:auto;
    }
}

.add-user-icon-wrapper:hover{
    color: $add-button-text-color-hover;
    border: 1px solid $add-button-border-on-hover; 
}

.editIcon {
    margin-inline-start: 9px;
    margin-top: 0px
}

.comm-input-field-style{
    background: $primary-background!important;
    height:40px;
    width: 100% !important;
    float: inline-start;
    padding-inline-start: 12px;
    padding-bottom: 2px;
    border: $border-color!important;
}

.search-bar-comm-style{
  padding-inline-start:3%;
  height:60px;
}

#contact_number_input::-webkit-outer-spin-button,
#contact_number_input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}
.users-basic-info-table {
  tbody {
    margin: 10px;
    .key-div {
      text-align: start;
      color: $dull-text-color;
      padding-inline-start: 3% !important;
      line-height: 36px;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
      width: 30%;
      font-weight: 500;
      input,select{
        padding-inline-start:4px;
      }
    }
  }
}

.activeclass {
  color: $active-blue;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}

.btn {
  font-size: $input-field-and-label-font-size !important;
  height: 100%;
}

.custom-control-label::before {
  background-color: $primary-background;
}

table.users-basic-info-table .editIcon {
  visibility: hidden;
}
table.users-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}

.disablefield {
  border: none !important;
  pointer-events: none;
}

.force-logout {
  position: relative;
  inset-inline-start: 5px;
  bottom: 4px;
}
.force-logout:hover {
  text-decoration: underline;
}
.activestatus {
  color: $active-green-color !important;
}
.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

.nav-item{
    color: $dull-text-color !important;
}

.active{
    background: $primary-background !important;
    color: $text-color !important;
}
.top-nav-bar{
    background: $primary-background;
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.tags-display-ul li:hover .show-tags-delete{
  visibility: visible;
}

.editIcon{
  visibility:hidden;
}

.group-name:hover .editIcon{
  visibility: visible;
}

.show-tags-delete{
  position: relative;
  top: 2px;
}

  .view-tags{
    font-size: 12px;
    height: 24px;
    display: inline-flex;
    margin:2px !important;
    border: $border-color!important;
    border-radius: 15px !important;
    min-width: 50px;
    padding: 0px !important;
    text-align: center;
    width:auto !important;
    div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
    }
  }
  

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}
.user-name-or-image{
    height: 60px;
    width: 60px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 56px;
    text-transform: uppercase;
    margin: 0 auto;
    font-size: 30px;
}

.primary-btn-style {
  margin-top: 1%;
  bottom: 8px;
  inset-inline-end: 0%;
  height:50px;
  width:100%;
  z-index:9;
  button {
    height: 38px !important;
    width: 70px;
    font-size:14px;
    margin-top:7px;
  }
  .btn-outline-secondary{
    float:inline-end;
  }
  .btn-outline-primary{
    margin-inline-end:15px;
  }
}

::v-deep{
  .multiselect {
    width:100%;
    margin: 3px 0px;
    color:$text-color;
    cursor:auto;
  }
  .multiselect__tags-wrap{
    display: block !important;
  }
  .multiselect__content-wrapper {
    display: none;
  }
  .multiselect__tag, .tags-style {
    background-color: $primary-background !important;
    border: $border-color;
    border-radius: 5px;
    margin-bottom:0px;
  }
  .multiselect__tags, .tags-style {
    background: $primary-background !important;
        border: $border-color !important;
  }

  .name-count-parent-wrap{
    background: transparent !important;
    border: none !important;
  }

  
  .multiselect__option--highlight {
    background: $bg-color-on-hover !important;
  }
  .multiselect__content {
    background: $secondary-background-color !important;
  }
  .multiselect__input,
  .multiselect__single {
    background: transparent !important;
    color: $text-color;
  }
  .multiselect__input:focus {
    outline: none;
    box-shadow: none;
  }
  .multiselect__tag-icon {
    color: $text-color !important;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $bg-color-on-hover !important;
    color: $text-color !important;
  }
  .multiselect__tag-icon:after {
    color: $secondary-text-color !important;
    font-size: 23px;
  }

  .multiselect__tag-icon {
    visibility: hidden;
  }

  .multiselect__tag:hover .multiselect__tag-icon {
    visibility: visible;
  }

  .multiselect * {
    font-size: $input-field-and-label-font-size !important;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .multiselect__placeholder {
    padding-top: 3px !important;
    margin-bottom:0px !important;
  }
  .multiselect {
    color: $text-color !important;
    font-size: $input-field-and-label-font-size !important;
    width: 100%;
    min-height: 38px;
  }
  .multiselect__single {
    padding-top: 3px;
  }
  .multiselect__option--selected {
    background: $bg-color-on-hover !important;
    color: $text-color;
  }
  .multiselect__content-wrapper {
    border: 1px solid $bg-color-on-hover !important;
    position: absolute;
    display: block;
    background: $text-color;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid $text-color;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
  }

  .multiselect__current,
  .multiselect__option {
    line-height: 12px !important;
  }

  .multiselect--above .multiselect__content-wrapper {
    background: $secondary-background-color !important;
  }
  .multiselect__tags {
    background: $primary-background !important;
    height: auto !important;
    padding: 8px 40px 8px 8px !important;
    min-height: 44px !important;
  }
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image-in-selected-option{
  border: 1px solid #3a3a3a;
  height: 27px;
  width: 27px;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  text-transform: uppercase;
  margin-top: -1px;
  margin-inline-start: -1px;
  }

.tags-style{
    display: inline-flex;
    margin-inline-end: 5px;
    margin-bottom: 2px !important;
    height: 27px;
    margin-inline-start: 3px;
  .user-name-display-as-tags{
      line-height: 27px;
      margin-inline-start: 6px;
  }
}


.remove-tag{
  color:$dull-text-color;
  line-height: 25px;
}

.remove-tag:hover{
  color:$text-color;
}

input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: 1px solid #909090 !important;

}

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}

::-webkit-scrollbar {
  width: 8px;
  height:8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $secondary-background-color;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $primary-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $bg-color-on-hover;
}

</style>